<template>
  <div class="nav-custom accordion d-flex">
      <div class="main-menu p-0">
        <v-navigation-drawer width="56" permanent color="#363636">
          <template v-for="(sidebar, key) in sidebarList">
            <div
                v-if="sidebar.id !== 'chat'"
                class="main-menu_item"
                :class="{active: currentSidebarId === sidebar.id}"
                @click="setItem(sidebar)"
                :key="key">
              <i class="fas" :class="sidebar.icon"></i>
            </div>
            <div
                v-else
                class="main-menu_item"
                :class="{active: currentSidebarId === sidebar.id}"
                @click="setItemChat(sidebar)"
                :key="key">
              <i class="fas" :class="sidebar.icon"></i>
            </div>
          </template>
          <template v-slot:append>
            <div
              @mouseover="userIconHover = true"
              @mouseleave="userIconHover = false"
              class="ml-2 mb-2"
            >
              <v-avatar
                v-if="userInfo && userInfo.avatar"
                :size="38"
                class="mr-2"
                style="cursor: pointer"
                @click="openEditAvatar"
              >
                <img
                  :src="userInfo.avatar"
                  :alt="userInfo.name"
                >
              </v-avatar>
              <v-avatar
                v-if="userInfo && !userInfo.avatar"
                :color="userInfo.avatar_default_info && userInfo.avatar_default_info.bgColor || '#ff66aa'"
                :size="38"
                class="mr-2"
                style="cursor: pointer"
                @click="openEditAvatar"
              >
                <span :style="{
                  color: userInfo.avatar_default_info && userInfo.avatar_default_info.textColor || '#ffffff'
                }">{{ userInfo.avatar_default_info && userInfo.avatar_default_info.text }}</span>
              </v-avatar>
            </div>
          </template>
        </v-navigation-drawer>
        <div v-if="userIconHover" class="userInfoWrapper">
          <div class="userInfoName">{{ userInfo.company.name }}</div>
          <div class="userInfoName">{{ userInfo.name }}</div>
        </div>
      </div>
      <div v-if="isChat">
      </div>
      <div v-else v-for="(sidebar, key) in sidebarList" :id="sidebar.id" class="main-menu_content" :class="{hide: isCurrentSidebar(sidebar), show: !isCurrentSidebar(sidebar)}" :key="key">
        <router-link v-for="(item, idx) in sidebar.items" :to="{name: item.component}" :key="'item_' + idx " class="main-menu_link grey--text text--darken-1">{{ item.label }}</router-link>
      </div>

    <v-dialog
      max-width="800"
      :value="avatarDialogFlg"
      persistent
    >
      <v-card>
        <v-card-title>アバター変更</v-card-title>
        <v-card-text>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-action-text class="pa-5">
                <v-avatar
                  v-if="avatarInputData.type === 'image'"
                  :size="38"
                  class="mr-2"
                >
                  <img
                    :src="avatarInputData.image"
                    :alt="avatarInputData.name"
                  >
                </v-avatar>
                <v-avatar
                  v-if="avatarInputData.type === 'text'"
                  :color="avatarInputData.bgColor"
                  :size="38"
                  class="mr-2"
                >
                  <span :style="{
                    color: avatarInputData.textColor
                  }">{{ avatarInputData.text }}</span>
                </v-avatar>
              </v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-action-text>
                <v-row>
                  <v-col cols="3">
                    <v-radio-group v-model="avatarInputData.type" class="mt-0">
                      <v-radio label="画像ファイル" value="image"></v-radio>
                      <v-radio label="テキスト＋色" value="text"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col v-if="avatarInputData.type === 'image'" cols="9">
                    <v-file-input
                      v-model="avatarImage"
                      outlined
                      dense
                      accept="image/*"
                      prepend-icon="mdi-camera"
                      truncate-length="30"
                      clearable
                    ></v-file-input>
                  </v-col>
                  <v-col v-if="avatarInputData.type === 'text'" cols="9">
                    <div style="width: 100px;">
                      <v-text-field
                        v-model="avatarInputData.text"
                        outlined
                        dense
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
          <v-row v-if="avatarInputData.type === 'text'">
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>背景色</v-list-item-title>
                  <v-list-item-action-text>
                    <v-color-picker
                      v-model="avatarInputData.bgColor"
                      dot-size="25"
                      swatches-max-height="100"
                    ></v-color-picker>
                  </v-list-item-action-text>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>テキスト色</v-list-item-title>
                  <v-list-item-action-text>
                    <v-color-picker
                      v-model="avatarInputData.textColor"
                      dot-size="25"
                      swatches-max-height="100"
                    ></v-color-picker>
                  </v-list-item-action-text>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ml-2"
            color="default"
            @click="closeEditAvatar()"
            :disabled="avatarLoadingFlg"
          >
            <v-icon x-small>mdi-close</v-icon>
            キャンセル
          </v-btn>
          <v-btn
            class="ml-2"
            color="primary"
            @click="saveAvatar"
            :loading="avatarLoadingFlg"
          >
            <v-icon x-small>mdi-check</v-icon>
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import { RepositoryFactory } from '@/api/RepositoryFactory'
const UserRepository = RepositoryFactory.get('users')

export default {
  name: 'Sidebar',
  data () {
    return {
      currentSidebarId: 'phone',
      // item submenu permission
      monitoring: { label: '稼働状況モニタリング', component: 'Monitoring', order: 1 },
      dashBoard: { label: '通話履歴', component: 'Dashboard', order: 2 },
      dial: { label: '架電', component: 'Dial', order: 3 },
      listPhoneAccount: { label: '電話帳', component: 'ListPhoneAccount', order: 1 },
      acd: { label: '通話割振り', component: 'Acd', order: 1 },
      absenceResponse: { label: '不在応答・発信', component: 'AbsenceResponse', order: 2 },
      listTwilioPhoneNumber: { label: '自番号管理', component: 'ListTwilioPhoneNumber', order: 3 },
      manageEndCallStatus: { label: '後作業自動切替', component: 'ManageEndCallStatus', order: 4 },
      agentList: { label: 'エージェント', component: 'AgentList', order: 5 },
      twilioSetting: { label: 'Twilio設定', component: 'TwilioSetting', order: 6 },
      companySetting: { label: 'クライアント管理メニュー', component: 'CompanySetting', order: 7 },

      // item menu permission
      phone: { id: 'phone', icon: 'fa-phone-alt', items: [], order: 1 },
      chat: { id: 'chat', icon: 'fa-comment', component: 'ChatMessage', items: [], order: 2 },
      lineMessage: { id: 'line-message', icon: 'fa-comment', items: [], order: 2 },
      address: { id: 'address', icon: 'fa-address-book', items: [], order: 3 },
      config: { id: 'config', icon: 'fa-cog', items: [], order: 4 },
      sidebarPermission: [],
      sidebarList: [],
      isChat: false,
      lineChat: { label: 'Lineメッセージ', component: 'LineChat', order: 1 },
      linePushMessages: { label: 'ブロードキャスト', component: 'FormPushMessages', order: 2 },
      lineSettingTextReply: { label: '自動応答メッセージ', component: 'FormSettingTextReply', order: 3 },

      // userIcon hover
      userIconHover: false,

      avatarDialogFlg: false,
      avatarLoadingFlg: false,

      /**
       * アバター入力値
       *
       * @type {
       *  type: 'image' | 'text' | null;
       *  image: string | null;
       *  bgColor: string | null;
       *  textColor: string | null;
       *  text: string | null;
       * }
       */
      avatarInputData: {
        type: null,
        image: null,
        bgColor: null,
        textColor: null,
        text: null
      },

      /**
       * アバター画像
       *
       * @type {File | null}
       */
      avatarImage: null
    }
  },
  watch: {
    /**
     * 入力ファイルの監視
     */
    avatarImage (val) {
      if (val && val.size && val.type.match(/^image\//)) {
        const reader = new FileReader()
        reader.onload = (ev) => {
          this.$set(this.avatarInputData, 'image', ev.target.result)
        }
        reader.readAsDataURL(val)
      } else {
        this.$set(this.avatarInputData, 'image', null)
      }
    }
  },
  created() {
    if (this.$route.name === 'ChatMessage') {
      this.isChat = true
    }
    this.$root.$on('redirect-line-chat', () => {
      if (this?.userInfo?.company && this.userInfo.company.can_chat_line) this.setItem(this.lineMessage)
    })
    this.$root.$on('redirect-list-phone', () => {
      this.setItem(this.address)
    })
    this.$root.$on('redirect-list-call', () => {
      this.setItem(this.phone)
    })
  },
  mounted () {
    // check show menu with role
    this.checkPermission()
    this.$nextTick(() => {
      this.currentSidebarId = this.currentSidebarPage
    })
  },
  methods: {
    setItem (item) {
      this.isChat = false
      this.$root.$emit('isChat', false)
      this.currentSidebarId = item.id
    },
    setItemChat (item) {
      if (this.$route.name === 'ChatMessage' || this.$route.name === 'ChatMessageOld') {
        bus.$emit('chat-again', true)
      }
      this.currentSidebarId = item.id
      this.isChat = true
      this.$root.$emit('isChat', true)
      this.$router.push({ name: item.component })
    },
    isCurrentSidebar (item) {
      return this.currentSidebarId !== item.id
    },

    // check role show menu sidebar: 1: admin, 2: Operator
    checkPermission () {
      this.sidebarPermission = []
      this.sidebarList = []
      if (this.userInfo && this.userInfo.company) {
        const roleUser = this.userInfo.role
        const userCompany = this.userInfo.company
        if (roleUser === 'admin' && !userCompany.disabled_phone) {
          this.sidebarPermission.push(this.phone)
          this.sidebarPermission.push(this.address)
          this.sidebarPermission.push(this.config)
          if (userCompany.can_chat_line) {
            this.sidebarPermission.push(this.lineMessage)
          }
          this.sidebarPermission.map((ite) => {
            if (ite.id === 'phone') {
              ite.items.push(this.monitoring)
              ite.items.push(this.dashBoard)
              ite.items.push(this.dial)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            if (ite.id === 'address') {
              ite.items.push(this.listPhoneAccount)
              ite.items.push(this.listTwilioPhoneNumber)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            if (ite.id === 'config') {
              ite.items.push(this.acd)
              ite.items.push(this.absenceResponse)
              ite.items.push(this.manageEndCallStatus)
              ite.items.push(this.agentList)
              ite.items.push(this.twilioSetting)
              if (userCompany && userCompany.role === 'kujira') {
                ite.items.push(this.companySetting)
              }
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            if (ite.id === 'line-message') {
              ite.items.push(this.lineChat)
              ite.items.push(this.linePushMessages)
              ite.items.push(this.lineSettingTextReply)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            return ite
          })
          this.sidebarPermission = [...new Set(this.sidebarPermission)]
          this.sidebarPermission.sort((a, b) => a.order - b.order)
        }
        if (roleUser === 'agent' && !userCompany.disabled_phone) {
          this.sidebarPermission.push(this.phone)
          this.sidebarPermission.push(this.address)
          if (userCompany.can_chat_line) {
            this.sidebarPermission.push(this.lineMessage)
          }
          this.sidebarPermission.map((ite) => {
            if (ite.id === 'phone') {
              ite.items.push(this.monitoring)
              ite.items.push(this.dashBoard)
              ite.items.push(this.dial)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            if (ite.id === 'address') {
              ite.items.push(this.listPhoneAccount)
              ite.items.push(this.listTwilioPhoneNumber)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            if (ite.id === 'line-message') {
              ite.items.push(this.lineChat)
              ite.items.push(this.linePushMessages)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            return ite
          })
          this.sidebarPermission = [...new Set(this.sidebarPermission)]
          this.sidebarPermission.sort((a, b) => a.order - b.order)
        }
        if (roleUser === 'a-cast' || (userCompany && userCompany.can_chat)) {
          this.sidebarPermission.push(this.chat)
          if (roleUser === 'admin') {
            this.sidebarPermission.push(this.config)
          }
          this.sidebarPermission.map((ite) => {
            if (ite.id === 'config') {
              ite.items.push(this.agentList)
              ite.items = [...new Set(ite.items)]
              ite.items.sort((a, b) => a.order - b.order)
            }
            return ite
          })
          this.sidebarPermission = [...new Set(this.sidebarPermission)]
          this.sidebarPermission.sort((a, b) => a.order - b.order)
        }
      }
      this.sidebarList = JSON.parse(JSON.stringify(this.sidebarPermission))
    },

    /**
     * アバター編集モーダルを開く
     *
     * @returns {void}
     */
    openEditAvatar () {
      this.avatarInputData = {
        type: this.userInfo.avatar ? 'image' : 'text',
        image: this.userInfo.avatar ?? null,
        bgColor: this.userInfo.avatar_default_info?.bgColor ?? '#000000',
        textColor: this.userInfo.avatar_default_info?.textColor ?? '#ffffff',
        text: this.userInfo.avatar_default_info?.text ?? ''
      }
      if (typeof this.avatarInputData.bgColor !== 'string' || !this.avatarInputData.bgColor.match(/^#\S{6}$/)) {
        this.$set(this.avatarInputData, 'bgColor', '#000000')
      }
      if (typeof this.avatarInputData.textColor !== 'string' || !this.avatarInputData.textColor.match(/^#\S{6}$/)) {
        this.$set(this.avatarInputData, 'textColor', '#ffffff')
      }
      this.avatarDialogFlg = true
    },

    /**
     * アバター編集モーダルを閉じる
     *
     * @returns {void}
     */
    closeEditAvatar () {
      this.avatarDialogFlg = false
      this.avatarInputData = {
        type: null,
        image: null,
        bgColor: '',
        textColor: '',
        text: ''
      }
      this.avatarImage = null
    },

    /**
     * アバターを保存する
     *
     * @returns {Promise<void>}
     */
    async saveAvatar () {
      // ロード中
      this.avatarLoadingFlg = true

      // 保存処理(1)
      const configHeader = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      const formData = new FormData()
      if (this.avatarImage) {
        formData.append('avatar', this.avatarImage)
      } else if (this.avatarInputData.type === 'text') {
        formData.append('delete_avatar', 1)
      }
      formData.append('role', this.userInfo.role)
      formData.append('role_id', this.userInfo.role_id)
      formData.append('status', this.userInfo.status)
      formData.append('name', this.userInfo.name)
      formData.append('email', this.userInfo.email)
      formData.append('id', this.userInfo.id)
      await UserRepository.updateSelf({ formData, configHeader })

      // 保存処理(2)
      await UserRepository.setAvatarDefault({
        bgColor: this.avatarInputData.bgColor,
        textColor: this.avatarInputData.textColor,
        text: this.avatarInputData.text
      })

      // 再取得
      const resultInfoUser = await UserRepository.getInfo()
      if (resultInfoUser.status_code === 200) {
        await this.$store.dispatch('user/setUserInfo', { ...resultInfoUser.user })
      }

      // ロード終了
      this.avatarLoadingFlg = false

      // モーダルを閉じる
      this.closeEditAvatar()
    }
  },
  computed: {
    currentSidebarPage () {
      const result = this.sidebarList.find((sidebar) => sidebar.component === this.$route.name)
      if (result) return result.id
      return this.currentSidebarId
    },
    ...mapGetters({
      userInfo: 'user/getUserInfo',
      userCompany: 'user/getUserCompany'
    })
  }
}
</script>
<style scoped lang="scss">
@media only screen and (min-width: 1200px){
  .v-application .nav-custom .main-menu_content {
    width: 275px;
  }
}
@media only screen and (max-width: 1200px){
  .v-application .nav-custom .main-menu_content {
    width: 190px;
  }
}
.userInfoWrapper {
  position:absolute;
  background-color: white;
  color: black;
  padding: 5px 10px;
  bottom: 45px;
  left: 30px;
  border: 0.5px solid black;
  border-radius: 8px;
  white-space: nowrap;
}
</style>
